import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('GET_FORM_DATA_APP'),
  ...actionTypes('GET_TASK_DATA'),
  ...actionTypes('GET_ACTIONS'),
  ...actionTypes('QUERY_TASKS'),
  ...actionTypes('GET_FORM_UPLOADS'),
  ...actionTypes('CLEAR_APPTRACK'),
  ...actionTypes('GET_PROCESS_INSTANCES_APP'),
  ...actionTypes('GET_APPTRACK_DETAILS'),
  ...actionTypes('SET_APPTRACK_LOADING'),
  ...actionTypes('OPEN_UPLOADED_FILE'),
  ...actionTypes('DOWNLOAD_UPLOADED_FILE'),
  ...actionTypes('FETCH_PROCESS_SAYT'),
  ...actionTypes('GET_OFFERS_HISTORY'),
  ...actionTypes('GET_PROVIDER_HISTORY_DETAILS'),
  ...actionTypes('GET_PROVIDER_HISTORY'),
  ...actionTypes('GET_ACTIVE_OFFERS'),
  ...actionTypes('CLEAR_ACTIVE_OFFERS'),
  ...actionTypes('UPLOAD_OFFERS'),
  ...actionTypes('OPEN_UPLOAD_OFFERS_MODAL'),
  ...actionTypes('OPEN_UPLOAD_PROVIDER_MODAL'),
  ...actionTypes('SET_SELECTED_OFFERS_FILE'),
  ...actionTypes('SET_SELECTED_PROVIDER_FILE'),
  ...actionTypes('GET_ALL_TASK_NAMES'),
  ...actionTypes('CLEAR_SAYT'),
  ...actionTypes('CANCEL_PROCESS'),
  ...actionTypes('CANCEL_PROCESS_EXTENDED'),
  ...actionTypes('DOWNLOAD_UPLOADED_PROVIDER_FILE'),
  ...actionTypes('UPLOAD_PROVIDER'),
  ...actionTypes('UNASSIGN_PROCESS_EXTENDED'),
}